import { Color } from 'csstype'

export * from './blue'
export * from './gray'
export * from './green'
export * from './orange'
export * from './purple'
export * from './red'
export * from './turquoise'
export * from './yellow'
export * from './pink'

export interface ColorScale {
  c10: Color
  c20: Color
  c30: Color
  c40: Color
  c50: Color
  c60: Color
  c70: Color
  c80: Color
  c90: Color
  c100: Color
}
